import type { Version } from './Project/types';

export const getPreviousCommit = (versions: Version[], currentCommit: string) => {
  let currentCommitIndex = null;
  let currentVersionIndex = null;
  versions.forEach((version, versionIndex) =>
    version.commits.forEach((commit, commitIndex) => {
      if (commit.commitHash === currentCommit) {
        currentCommitIndex = commitIndex;
        currentVersionIndex = versionIndex;
      }
    })
  );
  if (currentCommitIndex === null || currentVersionIndex === null) {
    return currentCommit;
  }
  const isLastCommit = currentCommitIndex === versions[currentVersionIndex].commits.length - 1;
  const isLastVersion = currentVersionIndex === versions.length - 1;
  if (isLastCommit && isLastVersion) {
    return currentCommit;
  }
  if (isLastCommit) {
    return (
      versions[currentVersionIndex + 1].commits[0].commitHash || versions[currentVersionIndex + 1].commitHash || ''
    );
  }
  const previousCommit = versions[currentVersionIndex].commits[currentCommitIndex + 1];
  return previousCommit?.commitHash;
};
